import { render, staticRenderFns } from "./EipList.vue?vue&type=template&id=3130d605"
import script from "./EipList.vue?vue&type=script&lang=js"
export * from "./EipList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports